export default __webpack_public_path__ + "static/media/ad-big.75b9d116.jpeg";